module.exports = __webpack_public_path__ + "static/media/between_fingers_failed.ac40d06b.svg";